import type { IFirestoreAlert } from "../Types/firestoreTypes";
import { parseJobReference } from "../Services/JobSignalService";
import { readRegisteredJob } from "../Services/JobRegistry";
import { getUserFromLS } from "../utils/getUserFromLS";
import { accountEditLabel, accountEditSummary } from "../Components/Account/accountEditStatus";
import { useObservedJob } from "./useObservedJob";

/** Sensitive action details/counts come from the authorized API, never Firestore. */
export function useJobAlertCopy(alert: IFirestoreAlert, visible = true) {
  const reference = alert.linkAction?.link_type === "JOB" ? parseJobReference(alert.linkAction.job) : undefined;
  const clientId = alert.linkAction?.client_id;
  const actorId = getUserFromLS()?.id;
  const job = visible && clientId && actorId && reference?.owner === "database_service" && reference.kind === "account_bulk"
    ? reference : undefined;
  const result = useObservedJob(job, signal => readRegisteredJob("account_bulk", job!, { clientId: clientId!, actorId: actorId! }, signal), false);
  const value = result.currentData;
  if (!job || !value || result.error) return { title: alert.title, description: alert.description };
  const label = accountEditLabel(value);
  if (value.status === "failed" || value.status === "cancelled") return {
    title: `${label} ${value.status}`,
    description: `${(value.counts.succeeded ?? 0).toLocaleString()} accounts updated. Review the results for details.`,
  };
  return { title: label, description: accountEditSummary(value) };
}
